<template>
  <div class="page-headline">
    <div class="page-headline-contents">
      <PageHeadlineTitle :title="title" />
    </div>
  </div>
</template>
<script>
import PageHeadlineTitle from '../../atoms/headlines/PageHeadlineTitle'
export default {
  components: { PageHeadlineTitle },
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
.page-headline {
  background-color: $white;
  text-align: center;
  padding: 24px 16px;

  &-contents {
    margin: auto;
    max-width: $max-contents-width;
  }
}
</style>
